module.exports = __webpack_public_path__ + "img/phone-outgoing-01.87be0c0e.svg";